import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateProductCategory($companyId: ID!, $attributes: ProductCategoryAttributes!) {
    createProductCategory(companyId: $companyId, attributes: $attributes) {
      productCategory {
        id
        ...CreatedProductCategory
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedProductCategory on ProductCategory {
    id
    category {
      id
      name
      color
    }
  }
`
